import { useLocalizedCurrencyFormatter } from 'shared/utils/currency';

export const useShareFormatter = () =>
  useLocalizedCurrencyFormatter(true, undefined, {
    style: 'percent',
    minimumFractionDigits: 1,
    maximumFractionDigits: 1,
    trailingZeroDisplay: 'auto',
  });
